import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { environment as env } from '../../../environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class ParcelService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(MsalService);
  private readonly userAuthService = inject(AuthService);

  constructor() {}
  handleError<T>() {
    return (error: HttpErrorResponse): Observable<T> => {
      let errorMessage = error.headers.get("message");
      let statusCode = error.status.valueOf();
      if ((error.error) && error.error.message) {
        errorMessage = error.error.message
      }
      const errors = { status: statusCode, error: errorMessage };
      return throwError(() => errors);
    };
  }

  handleHTTPSuccess(result: any) {
    return result;
  }

  searchItem(itemId: string | undefined, paginationData: any = {}, userClickPrev: boolean = false): Observable<any> {
    let params = `item/${itemId}`;
    if (paginationData && paginationData.hasMore) {
      params += `?keyMarker=${paginationData.nextKeyMarker}&versionIdMarker=${userClickPrev ? paginationData.previousVersionIdMarker :paginationData.nextVersionIdMarker}`;
    }
    return this.http.get<any>(`${env.diaBasePath}${params}`).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),

    );
  }

  searchImage(itemId: string | undefined, imageId: string | undefined): Observable<any> {
    // itemId = 'testdeepali234'
    // imageId = 'TEST202103PNG.png'
    let params = `item/${itemId}`;
    if(imageId){
      params+= `?imageNames=${imageId}`;
    }
    return this.http.get<any>(`${env.diaBasePath}${params}`).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),

    );
  }

  getUsers(): Observable<any> {
    return this.http.get<any>(`${env.diaBasePath}users`).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),

    );
  }

  getAllAssigned(queryParam = ''): Observable<any> {
    return this.http.get<any>(`${env.diaBasePath}items/assigned${queryParam}`).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),

    );
  }

  bulkAssignParcel(parcels: any): Observable<any> {

    return this.http.post(`${env.diaBasePath}item`, parcels).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }


  updateParcelAssigned(paramsData: { itemId: string; userId: string; status: string; updater?: string; section?: string, reAssignFromItemDetail?: string }): Observable<any> {

    let params = new HttpParams()
      .set('itemId', paramsData.itemId)
      .set('userId', paramsData.userId)
      .set('status', paramsData.status)
      .set('updater', paramsData.updater || '');

    if (paramsData.section != null) {
      params = params.set('section', paramsData.section);
    }
    if (paramsData.reAssignFromItemDetail != null) {
      params = params.set('reAssignFromItemDetail', paramsData.reAssignFromItemDetail);
    }
    return this.http.put(`${env.diaBasePath}item`, {}, { params }).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),

    );
  }

  getUnassigned(queryString?: string): Observable<any> {

    const diaApiBasePath = env.diaBasePath;

    var url = `${diaApiBasePath}user/items?userId=admin&status=unassigned`
    if (queryString) {
      url = url + queryString;
    }
    return this.http.get<any>(url).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }

  getAssignedToUser(queryString?: string): Observable<any> {

    const diaApiBasePath = env.diaBasePath;
    let account = this.authService.instance.getActiveAccount();
    let userId = account?.username;

    var url = `${diaApiBasePath}user/items?userId=${userId}&status=assigned`

    if (queryString) {
      url = url + queryString;
    }
    return this.http.get<any>(url).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }

  getSmartstoreMetadata(itemId: string | undefined): Observable<any> {
    const diaApiBasePath = env.diaBasePath;

    let params = `item/smartstore/metadata?itemId=${itemId}`;
    return this.http.get<any>(`${diaApiBasePath}${params}`).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }

  getSmartStoreImage(itemID: string, requestType: string, imageID: string, imageCat: string, responseType: 'blob'): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'image/jpeg'
    });
    let params = `item/smartstore?itemID=${itemID}&requestType=${requestType}&imageID=${imageID}&imageCat=${imageCat}`;
    return this.http.get(`${env.diaBasePath}${params}`, { headers: headers, responseType: 'blob' as 'json' }).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(error => {
        return this.http.get(`${env.diaBasePath}${params}`, { headers: headers, responseType: 'blob' as 'json' })
      }),
    );
  }

  getParcelSummary() {

    let account = this.authService.instance.getActiveAccount();
    let userId = account?.username;
    var url = `${env.diaBasePath}items/summary?userId=${userId}&status=assigned`

    return this.http.get<any>(url).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }

  getCameraList() {
    return [
      { label: 'All', value: null },
      { label: 'Camera 1', value: env.cams.CAMERA_ID_1_DEVICE_ID },
      { label: 'Camera 2', value: env.cams.CAMERA_ID_2_DEVICE_ID },
      { label: 'Camera 3', value: env.cams.CAMERA_ID_3_DEVICE_ID },
      { label: 'Mobile Camera 1', value: env.cams.MOBILE_CAMERA_1_DEVICE_ID },
      { label: 'Mobile Camera 2', value: env.cams.MOBILE_CAMERA_2_DEVICE_ID },
      { label: 'Mobile Camera 3', value: env.cams.MOBILE_CAMERA_3_DEVICE_ID }
    ];
  }
  getItemCodes() {
    return [
      { label: 'All', value: null },
      { label: 'E', value: 'E' },
      { label: 'C', value: 'C' },
      { label: 'R', value: 'R' },
      { label: 'L', value: 'L' },
      { label: 'D', value: 'D' },
      { label: 'U', value: 'U' }
    ];
  }
  getReprocessingItems(queryString?: string, param: string = 'userId=admin&status=reprocessing'): Observable<any> {

    const diaApiBasePath = env.diaBasePath;

    var url = `${diaApiBasePath}user/items?`
    if (param) {
      url = url + param;
    }
    if (queryString) {
      url = url + queryString;
    }
    return this.http.get<any>(url).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }
  deleteItems(items: any[] = []): Observable<any> {
    let itemIds: any = [];
    items.forEach(item => {
      itemIds.push({ "itemId": item.itemId })
    });

    return this.http.post(`${env.diaBasePath}deleteItem`, itemIds[0]).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }
  isAdmin() {
    const userGroup = this.userAuthService.getUserGroups();
    const matchForAdmin = userGroup.filter(grp => grp.includes('DIA-CustomsAdminUser-'));
    return matchForAdmin.length > 0 ? true : false;
  }
  deleteVersion(versionData: {} = {}) {
    return this.http.post(`${env.diaBasePath}deleteImage`, versionData).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }

  exportBarcode(data: any = {}) {
    var url = `${env.diaBasePath}items/exportDataToExcel?dateFrom=${data.dateFrom}&dateTo=${data.dateTo}`
    return this.http.get<any>(url, { responseType: 'text' as 'json' }).pipe(
      tap(res => {
        {
          this.handleHTTPSuccess(res);
        }
      }),
      catchError(this.handleError()),
    );
  }
  listUserLoginActivity() {
    var url = `${env.diaBasePath}listUserLoginActivity`
    return this.http.get<any>(url).pipe(
      tap(res => {
        {
          this.handleHTTPSuccess(res);
        }
      }),
      catchError(this.handleError()),
    );
  }
  udpateStatus(payLoad: any) {
    var url = `${env.diaBasePath}updateUserActivityStatus`
    return this.http.post(url, payLoad).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }

  submitRetrievalRequest(requestData: any): Observable<any> {
    return this.http.post(`${env.diaBasePath}images/restore/email`, requestData).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }

  listRetrievalRequests(): Observable<any> {
    return this.http.get<any>(`${env.diaBasePath}images/fetchRestoreRequestItems`).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }

  initiateRetrievalRequest(requestData: any): Observable<any> {
    return this.http.post(`${env.diaBasePath}images/restore`, requestData).pipe(
      tap(res => {
        this.handleHTTPSuccess(res);
      }),
      catchError(this.handleError()),
    );
  }
}
